module.exports = "<list-view\n  active-params=\"$ctrl.activeParams\"\n  filter-event=\"$ctrl.filterEvent\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  item-state=\"city\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  title=\"Cities\"\n  resource=\"City\"\n  transformer=\"CitiesTransforms\"\n  no-items-text=\"No Cities Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/cities/cities.html
// module id = 1457
// module chunks = 0